var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg5Starts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "96px",
    viewBox: "0 0 512 96",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Trustpilot_ratings_5star-RGB",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#00B67A",
    x: 0,
    y: 0,
    width: 96,
    height: 96
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#00B67A",
    x: 104,
    y: 0,
    width: 96,
    height: 96
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#00B67A",
    x: 208,
    y: 0,
    width: 96,
    height: 96
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#00B67A",
    x: 312,
    y: 0,
    width: 96,
    height: 96
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#00B67A",
    x: 416,
    y: 0,
    width: 96,
    height: 96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,64.7 L62.6,61 L68.7,79.8 L48,64.7 Z M81.6,40.4 L55.9,40.4 L48,16.2 L40.1,40.4 L14.4,40.4 L35.2,55.4 L27.3,79.6 L48.1,64.6 L60.9,55.4 L81.6,40.4 L81.6,40.4 L81.6,40.4 L81.6,40.4 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,64.7 L166.6,61 L172.7,79.8 L152,64.7 Z M185.6,40.4 L159.9,40.4 L152,16.2 L144.1,40.4 L118.4,40.4 L139.2,55.4 L131.3,79.6 L152.1,64.6 L164.9,55.4 L185.6,40.4 L185.6,40.4 L185.6,40.4 L185.6,40.4 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,64.7 L270.6,61 L276.7,79.8 L256,64.7 Z M289.6,40.4 L263.9,40.4 L256,16.2 L248.1,40.4 L222.4,40.4 L243.2,55.4 L235.3,79.6 L256.1,64.6 L268.9,55.4 L289.6,40.4 L289.6,40.4 L289.6,40.4 L289.6,40.4 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,64.7 L374.6,61 L380.7,79.8 L360,64.7 Z M393.6,40.4 L367.9,40.4 L360,16.2 L352.1,40.4 L326.4,40.4 L347.2,55.4 L339.3,79.6 L360.1,64.6 L372.9,55.4 L393.6,40.4 L393.6,40.4 L393.6,40.4 L393.6,40.4 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464,64.7 L478.6,61 L484.7,79.8 L464,64.7 Z M497.6,40.4 L471.9,40.4 L464,16.2 L456.1,40.4 L430.4,40.4 L451.2,55.4 L443.3,79.6 L464.1,64.6 L476.9,55.4 L497.6,40.4 L497.6,40.4 L497.6,40.4 L497.6,40.4 Z",
    id: "Shape",
    fill: "#FFFFFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5Starts);
export default __webpack_public_path__ + "static/media/5-starts.27f94caa0ce60c253acc54ed52f92893.svg";
export { ForwardRef as ReactComponent };